import React from "react";
import Shell from "@/components/layout/Shell";
import { AdminProvider, useAdmin } from "@/context/AdminContext";
import { useAuth } from "@/context/AuthContext";

const ADMIN_NAV = [
    { id: "overview", label: "Overview", icon: "Activity" },
    { id: "communities", label: "Communities", icon: "Globe" },
    { id: "servers", label: "Servers", icon: "Server" },
    { id: "players", label: "Players", icon: "UserCheck" },
    { id: "roles", label: "Roles", icon: "Key" },
    { id: "discord", label: "Discord", icon: "Bot" },
    { id: "moderation", label: "Moderation", icon: "ShieldAlert" },
    { id: "tickets", label: "Tickets", icon: "Ticket" },
    { id: "economy", label: "Economy", icon: "Coins" },
    { id: "shop", label: "Shop", icon: "Store" },
    { id: "kits", label: "Kits", icon: "Package" },
    { id: "events", label: "Events", icon: "Calendar" },
    { id: "maps", label: "Maps", icon: "MapPin" },
    { id: "announcements", label: "Announcements", icon: "Megaphone" },
    { id: "automation", label: "Automation", icon: "Cpu" },
    { id: "integrations", label: "Integrations", icon: "Zap" },
    { id: "analytics", label: "Analytics", icon: "BarChart3" },
    { id: "audit_logs", label: "Audit Logs", icon: "FileText" },
    { id: "settings", label: "Settings", icon: "Sliders" },
];

const COMMS = [
    { key: "ALL", name: "All Communities" },
    { key: "CODERS_PLAYGROUND", name: "Coder's Playground" },
    { key: "HAVEN_HAVOC", name: "Haven & Havoc" },
    { key: "THE_HIDEOUT", name: "The Hideout" },
];

function CommunitySwitcher() {
    const { community, setCommunity } = useAdmin();
    const { user } = useAuth();
    const scoped = user?.managed_communities?.length ? user.managed_communities : null;
    const options = scoped
        ? COMMS.filter((c) => scoped.includes(c.key))
        : COMMS;
    return (
        <div className="flex items-center gap-2">
            <span className="label-mono text-muted-foreground hidden md:inline">MANAGE:</span>
            <select
                data-testid="admin-community-switcher"
                value={community}
                onChange={(e) => setCommunity(e.target.value)}
                className="rounded-md border border-border bg-background px-3 py-1.5 text-sm font-heading uppercase tracking-wide text-foreground focus:border-burnt focus:outline-none"
            >
                {options.map((c) => (
                    <option key={c.key} value={c.key}>{c.name}</option>
                ))}
            </select>
        </div>
    );
}

export default function AdminLayout() {
    return (
        <AdminProvider>
            <Shell mode="admin" nav={ADMIN_NAV} basePath="/admin" topbarExtra={<CommunitySwitcher />} />
        </AdminProvider>
    );
}
